import { _ } from 'lodash';
import BlockVersions from '@/components/WorkflowBlocks/block-versions.js';

export const mustacheRegex = /{{\s*([^{}[\].]+(?:\[[^\[\]]*\])?(?:\.[^{}\.]+)*)\s*}}/g;
export function findMustacheVariables(inputString) {
  const regex = mustacheRegex;
  const matches = inputString.match(regex);
  return matches || [];
}

export const getBlockDefinition = async (key, version = null) => {
  let blockDefinition = null;
  const blockVersionEntry = BlockVersions[key];

  // Get all version for this particular type (key) of block
  const allowedBlockVersions = blockVersionEntry?.versions;
  if (!allowedBlockVersions) throw new Error(`[use-workflow] Block versions not found for ${key}`);

  // Attempt to pull the block definition for the specified version
  // Pulls the latest version if no version is specified
  if (!version) blockDefinition = [...allowedBlockVersions].pop();
  else blockDefinition = allowedBlockVersions.find((block) => block.name === version);
  if (!blockDefinition) throw new Error(`[use-workflow] Block version ${version} not found for ${key}`);

  // const definition = await import(`./workflow-blocks/${key}/${key}-${blockDefinition.name}.js`);
  const definition = await import(`../composables/workflow-blocks/${key}/${key}-${blockDefinition.name}.js`);
  if (!definition || !definition.block) throw new Error(`[use-workflow] Block definition not found for ${key}`);

  // Returns the block definition for this block's version, or the latest version if no version is specified
  return _.cloneDeep(definition.block);
};
